import React, { Component } from 'react';
import { connect } from 'react-redux';

import ButtonBase from 'material-ui/ButtonBase';
import ArrowRight from '@material-ui/icons/KeyboardArrowRight';
import ArrowLeft from '@material-ui/icons/KeyboardArrowLeft';

import * as CalendarState from '../../../state/reducer/calendar/calendar';
import * as CalendarCollapseState from '../../../state/reducer/calendarCollapse/calendarCollapse';

import Console from '../../../lib/debug';
import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';

const MONTH_TYPES = [
    ProgramTypes.TYPES.TEAM,
    ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.CALENDAR
];

const checkIsProgram = type => {
    if (!type) {
        return false;
    }

    return !MONTH_TYPES.includes(type);
};

class CalendarCollapseHeader extends Component {
    renderHeader(dayHeader) {
        const COLLAPSED_WIDTH = 60;
        let classes = 'day-head';
        let style = { width: COLLAPSED_WIDTH };
        let icons;

        if (dayHeader.status) {
            classes += ' collapsed';
        } else {
            let key = CalendarCollapseState.getKey(
                this.props.programType,
                this.props.programId
            );
            let width = CalendarCollapseState.getExpandedWidth(key);
            icons = [<ArrowRight key="right" />, <ArrowLeft key="left" />];
            style = { width };
        }

        return (
            <div className={classes} style={style} key={dayHeader.name}>
                <ButtonBase
                    focusRipple
                    className="btn-collapse"
                    onClick={() => this.toggleCollapse(dayHeader)}
                >
                    <span className="day-name"> {dayHeader.name} </span>
                    <span className="collapse-icons">{icons}</span>
                </ButtonBase>
            </div>
        );
    }

    toggleCollapse(dayHeader) {
        let key = CalendarCollapseState.getKey(
            this.props.programType,
            this.props.programId
        );
        CalendarState.toggleHeaderCollapse(key, dayHeader);
    }

    render() {
        Console.render('CalendarCollapseHeader');
        const {
            programId,
            programType,
            dayHeaders,
            trainingWeekStartsOnMonday
        } = this.props;

        const hasProgramId = typeof programId === 'number';
        const hasProgramType = typeof programType === 'number';

        if (!hasProgramId && !hasProgramType) {
            return null;
        }

        const collapseStatusKey = CalendarCollapseState.getKey(
            programType,
            programId
        );
        const isProgram = checkIsProgram(this.props.programType);
        const columnHeaders = dayHeaders[collapseStatusKey];
        if (!columnHeaders) {
            return <section className="days-handlers" />;
        }

        const headers = [];
        for (let i = 0; i < columnHeaders.length; i++) {
            if (i === 0 && trainingWeekStartsOnMonday && !isProgram) {
                continue;
            }
            headers.push(this.renderHeader(columnHeaders[i]));
        }

        if (trainingWeekStartsOnMonday && !isProgram) {
            headers.push(this.renderHeader(columnHeaders[0]));
        }
        return <section className="days-handlers">{headers}</section>;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        dayHeaders: state.calendarCollapse.calendarCollapseConfig,
        programType: state.calendar.infoTree.programType,
        trainingWeekStartsOnMonday:
            state.app &&
            state.app.userProfile &&
            state.app.userProfile.training_week_starts_on_monday
    };
};

export default connect(mapStateToProps)(CalendarCollapseHeader);



// WEBPACK FOOTER //
// ./src/view/calendar/components/CalendarCollapseHeader.jsx